import Link from "next/link";
import Logo from "./Logo";

export default function TopBar({ title }: { title: string }) {
  return (
    <header className="relative z-20 flex items-center justify-between px-5 sm:px-8 py-3 border-b border-electric/20">
      <Link href="/" className="flex items-center">
        <Logo height={40} />
      </Link>
      <span className="font-display tracking-[0.3em] text-sun text-sm glow-sun">
        {title}
      </span>
      <Link href="/" className="btn btn-ghost text-xs py-1.5 px-3">
        ◀ HOME
      </Link>
    </header>
  );
}
